import React, { Fragment, useEffect, useState } from "react";
import GalaxyCard from "./galaxyCardInPopup";
import { ILiftOffHeader } from "../../../../model/interface/subject";
import Select from "react-select";
import {
  ILiftOffGalaxyStandardInfo,
  ILiftOffGalaxyTopic,
} from "../../../../model/interface/liftOffGalaxyStandard";
import { getLiftOffGalaxyStandardInfo } from "../../../../api/liftOffGalaxyStandard.service";
import constant from "../../../../utils/constant";
import { TicketIcon, XIcon } from "@heroicons/react/outline";
import { CheckIcon, DeleteIcon, TickIcon } from "../../../../assets/icons";
import {
  ILiftOffDiagnosticTest,
  ILiftOffDiagnosticTestQuestion,
  IQuestionExistsRequest,
  IStandardExistsRequest,
} from "../../../../model/interface/liftOffDiagnosticTest";
import { connect } from "react-redux";
import {
  checkQuestionExists,
  checkStandardExists,
} from "../../../../api/liftOffDiagnosticTestQuestion.service";
import { toast } from "react-toastify";
import { saveLFDiagnosticTest } from "../../../../api/liftOffDiagnosticTest.service";
import { IDropDown } from "../../../../model/shared/dropDown";
import { getGradeAll } from "../../../../api/subject.service";

interface GalaxyPopupProps {
  liftOffHeaderId: number;
  showPopup: (show: boolean) => void;
  selectedStandards: Array<ILiftOffGalaxyTopic>;
  liftOffDiagnosticTestID?: number;
  subjectId: number;
  testName: string;
  profile: any;
  lfDiagTestQuestions: Array<ILiftOffDiagnosticTestQuestion>;
  saveTest(data: any): void;
}

interface ITempQuestion {
  index: number;
  testId: number;
  testQuestionId: number;
  standardId: number;
  questionId1: number;
  questionId2: number;
  isStandardGroup: boolean;
  gradeId: number;
  grade?: string;
}

interface IStandardExistsResponse {
  StandardPresentInTest: boolean;
}

const GalaxyPopup = (props: GalaxyPopupProps) => {
  const defaultPageNumber = 1;
  const [selectedGalaxyId, setSelectedGalaxyId] = useState(0);
  const [disableAddGalaxy, setDisableAddGalaxy] = useState(true);
  const [grades, setGrades] = useState<Array<IDropDown>>([]);
  const [lfGalaxyInfo, setLFGalaxyInfo] = useState<
    Array<ILiftOffGalaxyStandardInfo>
  >([]);
  const [selectedTestName, setTestName] = useState(props.testName);
  const [selectedStandards, setSelectedStandards] = useState<
    Array<ILiftOffGalaxyTopic>
  >(props.selectedStandards);
  const [testId, setTestId] = useState<number>(
    props.liftOffDiagnosticTestID ?? 0
  );
  const [testQuestions, setTestQuestions] = useState<
    Array<ILiftOffDiagnosticTestQuestion>
  >(props.lfDiagTestQuestions);
  const [loading, setLoading] = useState<boolean>(false);
  const [reset, setReset] = useState<boolean>(false);
  const [tempQuestions, setTempQuestions] = useState<Array<ITempQuestion>>([]);

  const loadExistingTestQuestions = () => {
    const ds: Array<ITempQuestion> = [];
    props.lfDiagTestQuestions.map((item, index) => {
      const tempQuestion: ITempQuestion = {
        index: index,
        testId: item.liftOffDiagnosticTestID,
        testQuestionId: item.liftOffDiagTestQuestionId,
        standardId: item.standardReferenceId,
        questionId1: item.questionId1,
        questionId2: item.questionId2,
        isStandardGroup: item.isStandardGroup,
        gradeId: item.gradeId,
        grade: item.grade,
      };
      ds.push(tempQuestion);
    });
    setTempQuestions(ds);
  };

  useEffect(() => {
    bindData();
  }, [props.liftOffHeaderId]);

  useEffect(() => {
    if (lfGalaxyInfo && lfGalaxyInfo.length > 0) {
      setSelectedGalaxyId(lfGalaxyInfo[0].liftOffGalaxyId);
    }
  }, [lfGalaxyInfo]);

  const getData = async () => {
    const response = await getLiftOffGalaxyStandardInfo(props.liftOffHeaderId);
    const lfGalaxyIds = response.data.map((i) => i.liftOffGalaxyId);
    const maxLFGalaxyId = Math.max(...lfGalaxyIds);
    const lfGalaxydata = response.data;

    if (lfGalaxyIds.length > 0) {
      [...Array(maxLFGalaxyId)].map((item, index) => {
        if (!lfGalaxyIds.includes(index + 1)) {
          const lfGalaxy: ILiftOffGalaxyStandardInfo = {
            liftOffHeaderId: props.liftOffHeaderId,
            liftOffGalaxyId: index + 1,
            standardCount: 0,
            liftOffGalaxyName: "Galaxy " + (index + 1),
          };
          lfGalaxydata.push(lfGalaxy);
        }
      });

      const data = lfGalaxydata.sort((a, b) => {
        return b.liftOffGalaxyId - a.liftOffGalaxyId;
      });
      setLFGalaxyInfo(data);
    } else {
      setLFGalaxyInfo(response.data);
    }
  };

  const bindGradeData = () => {
    async function gradeReload() {
      setLoading(true);
      const response = getGradeAll(100, defaultPageNumber);

      const data = (await response).data;
      if (data.data.length > 0) {
        data.data.sort(
          (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
        );
        const dropdownData = data.data.map((eachGradeData) => {
          return {
            value: eachGradeData.gradeId || 0,
            label: `${eachGradeData.name}`,
          };
        });

        setGrades(dropdownData);
      }

      setLoading(false);
    }
    gradeReload();
  };

  const bindData = () => {
    setDisableAddGalaxy(false);
    getData();
    loadExistingTestQuestions();
    bindGradeData();
  };

  const handleGalaxyCardSelection = (lfGalaxyId: number) => {
    setSelectedGalaxyId(lfGalaxyId);
  };

  const handleTestNameChange = (name: string) => {
    setTestName(name);
  };

  const handleGradeChange = (
    e: any,
    index: number,
    standard: ILiftOffGalaxyTopic
  ) => {
    let ds: Array<ITempQuestion> = [];
    ds = tempQuestions.filter((item) => item.index !== index);
    let tempQuestion: ITempQuestion = tempQuestions.filter(
      (item) => item.index == index
    )[0];
    if (tempQuestion == undefined || tempQuestion == null) {
      tempQuestion = {
        index: index,
        testId: testId,
        testQuestionId: 0,
        standardId: standard.standardId,
        questionId1: 0,
        questionId2: 0,
        isStandardGroup: standard.isStandardGrouped,
        gradeId: e.value,
        grade: e.label,
      };
    } else {
      tempQuestion.gradeId = e.value;
      tempQuestion.grade = e.label;
    }

    setTempQuestions([...ds, tempQuestion]);
  };

  const handleQuestionId1Change = (
    index: number,
    questionId: number,
    standard: ILiftOffGalaxyTopic
  ) => {
    if (reset) {
      setReset(false);
    }
    if (isNaN(questionId)) {
      questionId = 0;
    }
    let ds: Array<ITempQuestion> = [];
    ds = tempQuestions.filter((item) => item.index !== index);
    let tempQuestion: ITempQuestion = tempQuestions.filter(
      (item) => item.index == index
    )[0];
    if (tempQuestion == undefined || tempQuestion == null) {
      tempQuestion = {
        index: index,
        testId: testId,
        testQuestionId: 0,
        standardId: standard.standardId,
        questionId1: questionId,
        questionId2: 0,
        isStandardGroup: standard.isStandardGrouped,
        gradeId: standard.gradeId,
        grade: standard.grade,
      };
    } else {
      tempQuestion.questionId1 = questionId;
    }

    setTempQuestions([...ds, tempQuestion]);
  };

  const handleQuestionId2Change = (
    index: number,
    questionId: number,
    standard: ILiftOffGalaxyTopic
  ) => {
    if (reset) {
      setReset(false);
    }
    if (isNaN(questionId)) {
      questionId = 0;
    }

    let ds: Array<ITempQuestion> = [];
    ds = tempQuestions.filter((item) => item.index !== index);

    let tempQuestion: ITempQuestion = tempQuestions.filter(
      (item) => item.index == index
    )[0];
    if (tempQuestion == undefined || tempQuestion == null) {
      tempQuestion = {
        index: index,
        testId: testId,
        testQuestionId: 0,
        standardId: standard.standardId,
        questionId1: questionId,
        questionId2: 0,
        isStandardGroup: standard.isStandardGrouped,
        gradeId: standard.gradeId,
        grade: standard.grade,
      };
    } else {
      tempQuestion.questionId2 = questionId;
    }

    setTempQuestions([...ds, tempQuestion]);
  };

  const confirmDeleteStandard = (standardId: number, orderNo: number) => {
    const filteredArray = selectedStandards.filter(
      (item) => item.standardId !== standardId
    );

    const updatedTestQuestions = testQuestions.map((testQuestion) => {
      if (testQuestion.standardReferenceId !== standardId) {
        return testQuestion;
      } else {
        testQuestion.isActive = false;
        return testQuestion;
      }
    });

    const filteredTempQuestions = tempQuestions.filter(
      (q) => q.standardId !== standardId
    );
    setTempQuestions(filteredTempQuestions);
    setTestQuestions(updatedTestQuestions);
    setSelectedStandards(filteredArray);
  };

  const validateQuestion = (question: ILiftOffDiagnosticTestQuestion) => {
    let isValid = true;

    if (question.questionId1 === 0 || question.questionId2 === 0) {
      toast.error("QuestionId is required");
      isValid = false;
    } else if (question.standardReferenceId === 0) {
      toast.error("StandardId is required");
      isValid = false;
    }
    return isValid;
  };

  const validateStandard = async (standardId: number) => {
    let isValid = true;
    const request: IStandardExistsRequest = {
      liftOffDiagnosticTestId: testId,
      standardReferenceId: standardId,
      subjectId: props.subjectId,
    };
    const response = checkStandardExists(request);
    const data = (await response).data;
    if (data.standardPresentInTest) {
      toast.error("Standard/Standard Group already added to other heirarchy");
      isValid = false;
      return isValid;
    }
    return isValid;
  };

  const validateTest = () => {
    let isValid = true;
    if (selectedTestName.length == 0) {
      toast.error("Please enter Heirarchy name");
      isValid = false;
    } else if (tempQuestions.length == 0) {
      toast.error("Please add valid questions");
      isValid = false;
    }
    return isValid;
  };

  const showErrorMessage = (errorBit: number) => {
    if (errorBit === -1) {
      toast.error("QuestionId not present in Standard");
    } else if (errorBit === -2) {
      toast.error("Duplicate QuestionId not allowed in test");
    }
  };

  const handleSaveTest = async () => {
    if (validateTest()) {
      const testQuestionsToSave = tempQuestions.map((q, index) => {
        const question: ILiftOffDiagnosticTestQuestion = {
          liftOffDiagTestQuestionId: q.testQuestionId,
          liftOffDiagnosticTestID: q.testId,
          standardReferenceId: q.standardId,
          isStandardGroup: q.isStandardGroup,
          questionId1: q.questionId1,
          questionId2: q.questionId2,
          orderNumber: q.index + 1,
          isActive: true,
          createdByUserId: props.profile?.userId ?? 1,
          gradeId: q.gradeId === 0 ? 1 : q.gradeId,
          grade: "",
        };
        return question;
      });

      const test: ILiftOffDiagnosticTest = {
        liftOffDiagnosticTestId: testId,
        name: selectedTestName,
        liftOffHeaderId: props.liftOffHeaderId,
        subjectId: props.subjectId,
        isActive: true,
        createdByUserId: props.profile?.userId ?? 1,
      };

      const data: any = {
        test: test,
        questions: testQuestionsToSave,
      };

      props.saveTest(data);
    }
  };

  return (
    <Fragment>
      <div className="fixed z-10 inset-0 overflow-y-auto">
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen">
            &#8203;
          </span>
          <div className="inline-block w-full align-bottom bg-white px-4 pt-5 pb-8 text-left  shadow-xl transform transition-all sm:align-middle sm:max-w-[90%] sm:w-full sm:p-6">
            <div className=" flex justify-end">
              <button
                onClick={() => props.showPopup(false)}
                type="button"
                className="bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
              >
                <XIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className={"pt-6 border-b pb-6"}>
              <div className="grid sm:grid-cols-4 md:grid-cols-8  xl:grid-cols-12 gap-6 text-sm">
                <div className="col-span-7">
                  <div className={"self-center place-self-srt col-span-2"}>
                    Heirarchy Name
                  </div>
                  <div className={"w-full mt-1"}>
                    <input
                      className="shadow appearance-none border border-gray-300 rounded-sm shadow-md w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      type="text"
                      value={selectedTestName}
                      onChange={(e) => {
                        handleTestNameChange(e.target.value);
                      }}
                    ></input>
                  </div>

                  {
                    <>
                      <div className="flex-grow rounded-lg mt-2">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead className="bg-primary-color">
                            <tr>
                              <th
                                scope="col"
                                className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider rounded-tl-lg"
                              >
                                <span className="flex">Id</span>
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                              >
                                <span className="flex">Code</span>
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                              >
                                <span className="flex">Standard / Group</span>
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                              >
                                <span className="flex">Grade</span>
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                              >
                                <span className="flex">QuestionId 1</span>
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                              >
                                <span className="flex">QuestionId 2</span>
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white tracking-wider  rounded-tr-lg"
                              >
                                <span className="flex">Actions</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-50">
                            {selectedStandards.length > 0 &&
                              selectedStandards.map((standard, index) => {
                                const standardId: any = standard.standardId;
                                return (
                                  <tr
                                    className={
                                      index % 2 === 0
                                        ? "bg-white"
                                        : "bg-gray-100"
                                    }
                                    key={index}
                                  >
                                    <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                      {standard.standardId}
                                    </td>
                                    <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                      {standard.code}
                                    </td>
                                    <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                      {standard.standardName}
                                    </td>
                                    <td className="py-2 text-sm text-left font-normal text-gray-500">
                                      <div className="">
                                        <Select
                                          defaultValue={{
                                            label: testQuestions.filter(
                                              (q) =>
                                                q.standardReferenceId ==
                                                standardId
                                            )[0]?.grade,
                                            value: testQuestions
                                              .filter(
                                                (q) =>
                                                  q.standardReferenceId ==
                                                  standardId
                                              )[0]
                                              ?.gradeId.toString(),
                                          }}
                                          onChange={(e) => {
                                            handleGradeChange(
                                              e,
                                              index,
                                              standard
                                            );
                                          }}
                                          options={grades?.map((grade) => ({
                                            value: grade.value.toString(),
                                            label: grade.label,
                                          }))}
                                          className="text-gray-900 cursor-default select-none relative py-2"
                                          isSearchable={true}
                                          theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                              ...theme.colors,
                                              primary25: "#B3B3B3",
                                              primary: "#041E42",
                                            },
                                          })}
                                          styles={{
                                            control: (base, state) => ({
                                              ...base,
                                              borderColor:
                                                document.getElementsByClassName(
                                                  "dark"
                                                )?.length > 0
                                                  ? "#6B7280"
                                                  : "#D1D5DB",
                                              borderWidth: "1px",
                                              "&:hover": {
                                                borderColor:
                                                  state.isFocused &&
                                                  document.getElementsByClassName(
                                                    "dark"
                                                  )?.length > 0
                                                    ? "#6b7280"
                                                    : state.isFocused
                                                    ? "#4c5563"
                                                    : "",
                                              },
                                            }),
                                            singleValue: (base) => ({
                                              ...base,
                                              color:
                                                document.getElementsByClassName(
                                                  "dark"
                                                )?.length > 0
                                                  ? "white"
                                                  : "#374051",
                                            }),
                                            input: (base) => ({
                                              ...base,
                                              color:
                                                document.getElementsByClassName(
                                                  "dark"
                                                )?.length > 0
                                                  ? "white"
                                                  : "",
                                            }),
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td className="px-3 py-2 text-left cursor-pointer font-medium text-indigo-600 transaction ease-in-out duration-300">
                                      <input
                                        id={`questionId1_${index}`}
                                        name={`questionId1_${index}`}
                                        defaultValue={
                                          testQuestions.filter(
                                            (q) =>
                                              q.standardReferenceId ==
                                              standardId
                                          )[0]?.questionId1
                                        }
                                        onChange={(e) => {
                                          handleQuestionId1Change(
                                            index,
                                            parseInt(e.target.value),
                                            standard
                                          );
                                        }}
                                        type="number"
                                        className="block w-full max-w-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                                      />
                                    </td>
                                    <td className="px-3 py-2 text-left cursor-pointer font-medium text-indigo-600 transaction ease-in-out duration-300">
                                      <input
                                        id={`questionId2_${index}`}
                                        name={`questionId2_${index}`}
                                        defaultValue={
                                          testQuestions.filter(
                                            (q) =>
                                              q.standardReferenceId ==
                                              standardId
                                          )[0]?.questionId2
                                        }
                                        onChange={(e) => {
                                          handleQuestionId2Change(
                                            index,
                                            parseInt(e.target.value),
                                            standard
                                          );
                                        }}
                                        type="number"
                                        className="block w-full max-w-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                                      />
                                    </td>
                                    <td className="px-3 py-2 text-left cursor-pointer font-medium text-indigo-600 hover:text-red-500 transaction ease-in-out duration-300">
                                      <div className="flex justify-center items-center">
                                        <DeleteIcon
                                          title="Delete"
                                          className="w-4 text-xs cursor-pointer hover:text-red-500 transaction ease-in-out duration-300 text-gray-700"
                                          onClick={() => {
                                            confirmDeleteStandard(
                                              standard.standardId,
                                              standard.orderNumber
                                            );
                                          }}
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                      <div className="flex justify-end mt-1">
                        <button
                          type="submit"
                          className="ml-3 inline-flex items-center px-3 py-2 mt-4 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                          onClick={handleSaveTest}
                        >
                          {testId > 0 ? "Update Test" : "Add Test"}
                        </button>
                      </div>
                    </>
                  }
                </div>

                <div className="col-span-5">
                  {lfGalaxyInfo.map((item, index) => (
                    <GalaxyCard
                      key={index}
                      liftOffGalaxyName={item.liftOffGalaxyName}
                      liftOffGalaxyId={item.liftOffGalaxyId}
                      liftOffHeaderId={props.liftOffHeaderId}
                      isLastGalaxyCard={
                        item.liftOffGalaxyId == lfGalaxyInfo.length
                      }
                      isGalaxyCardSelected={true}
                      setDisableAddGalaxy={setDisableAddGalaxy}
                      setSelectedStandards={setSelectedStandards}
                      onClicked={(lfGalaxyId) => {
                        handleGalaxyCardSelection(lfGalaxyId);
                      }}
                      selectedStandards={selectedStandards}
                      testId={testId}
                      subjectId={props.subjectId}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(GalaxyPopup);
